import SliderInterface from '../../Slider/interfaces/SliderInterface';
import Menu from '../../../shared/class/Menu';
import Tabs from '../../Tabs/Tabs';

/**
 * Class Menu Primary.
 */
export default class MenuPrimaryMobile {
  static openMenuClass = 'js-openMenu';

  static openSubMenuClass = 'js-openSubMenu';

  static heightMenu: number;

  constructor(
    selectorOpen: string,
    selectorClose: string,
    selectorMenu: string,
    selectorSubMenu: string,
    optionsSlider = {}
  ) {
    const eltMenu: HTMLElement = document.querySelector(selectorMenu);
    const eltOpenMenu: HTMLElement = document.querySelector(selectorOpen);
    const openSubMenu: NodeListOf<HTMLElement> =
      document.querySelectorAll(selectorSubMenu);
    const eltCloseMenus: NodeListOf<HTMLElement> =
      document.querySelectorAll(selectorClose);
    const historyBackSubMenus: NodeListOf<HTMLElement> =
      document.querySelectorAll('.js-menuNav');

    if (eltMenu) {
      window.addEventListener('load', () => {
        // Open Menu & Remember scroll position
        Menu.openMenu(eltOpenMenu, eltMenu, MenuPrimaryMobile.openMenuClass);

        // Open Sub Menu
        MenuPrimaryMobile.openSubMenu(openSubMenu);

        // Close Menu
        Menu.closeMenu(
          eltCloseMenus,
          eltMenu,
          MenuPrimaryMobile.openMenuClass,
          MenuPrimaryMobile.openSubMenuClass
        );

        // Close Sub Menu
        MenuPrimaryMobile.historyBackSubMenu(historyBackSubMenus);

        // Sliders
        MenuPrimaryMobile.importSliderMobile(eltMenu, optionsSlider);

        // Set height submenu
        MenuPrimaryMobile.heightMenu = document.querySelector(
          '.c-menuPrimary, .c-menuPrimaryNew'
        )
          ? document.querySelector('.c-menuPrimary, .c-menuPrimaryNew')
              .scrollHeight
          : 0;

        document.documentElement.style.setProperty(
          '--menu-mobile-height',
          `${MenuPrimaryMobile.heightMenu}px`
        );

        // Add Tabs
        Tabs.create('.c-menuPrimary__mobileTabs');

        // Open menu Account
        MenuPrimaryMobile.openMenuAccount();
      });
    }
  }

  /*
   * Open Sub Menu Mobile
   * */
  private static openSubMenu(openSubMenu: NodeListOf<HTMLElement>) {
    const arrayOpenSubMenu: Array<HTMLElement> = Array.from(openSubMenu);

    arrayOpenSubMenu.forEach((openSubMenuElt: HTMLElement) => {
      const link = openSubMenuElt.querySelector('.js-menuTitle');
      const subMenu = openSubMenuElt.querySelector('.js-menuSubMenu');

      if (subMenu) {
        link.addEventListener('click', (event) => {
          event.preventDefault();

          // Open sub menu
          subMenu.classList.add(MenuPrimaryMobile.openSubMenuClass);

          // Update height submenu if current height > parent height
          const heightSubMenu = subMenu.querySelector(
            ':scope > .l-container-fluid'
          );
          MenuPrimaryMobile.heightMenu =
            heightSubMenu &&
            heightSubMenu.scrollHeight > MenuPrimaryMobile.heightMenu
              ? heightSubMenu.scrollHeight
              : MenuPrimaryMobile.heightMenu;

          document.documentElement.style.setProperty(
            '--menu-mobile-height',
            `${MenuPrimaryMobile.heightMenu}px`
          );

          // Scroll top to element
          subMenu.scrollIntoView({ behavior: 'smooth' });

          // Disable link
          return false;
        });
      }
    });
  }

  /*
   * History back for Sub Menu Mobile
   * */
  private static historyBackSubMenu(
    historyBackSubMenus: NodeListOf<HTMLElement>
  ) {
    const arrayHistoryBackSubMenus: Array<HTMLElement> =
      Array.from(historyBackSubMenus);

    arrayHistoryBackSubMenus.forEach((historyBackSubMenu: HTMLElement) => {
      historyBackSubMenu.addEventListener(
        'click',
        (event) => {
          event.stopPropagation();

          // History back
          historyBackSubMenu
            .closest('.js-openSubMenu')
            .classList.remove(MenuPrimaryMobile.openSubMenuClass);
        },
        { passive: true }
      );
    });
  }

  /*
   * Open menu Account
   * */
  private static openMenuAccount() {
    const openAccountMenu: HTMLElement = document.querySelector(
      '.is-logged .c-menuPrimary__menuTertiary__account'
    );

    if (openAccountMenu) {
      const menuClose: HTMLElement = document.querySelector('.js-menuClose');
      const openMenuAccount: HTMLElement = document.querySelector(
        '.c-menuTertiary__item__linkMobile'
      );

      openAccountMenu.addEventListener('click', (event) => {
        event.stopPropagation();
        event.preventDefault();
        // Close menu
        menuClose.click();
        // Open menu Account
        openMenuAccount.click();
      });
    }
  }

  /*
   * Import dynamically slider in menu
   * */
  private static importSliderMobile(eltMenu: HTMLElement, options: {}) {
    if (eltMenu) {
      eltMenu.addEventListener(
        'mouseenter',
        () => {
          import(
            /* webpackPrefetch: true */ /* webpackChunkName: 'prefetch-slider' */ '../../Slider/Slider'
          ).then(({ default: Slider }) => {
            const slidersMenu: NodeListOf<HTMLElement> =
              document.querySelectorAll(
                '.c-menuPrimarySubMenu--mobileGallery  .js-sliderMenuMobile'
              );

            // Add slider in all element slider
            slidersMenu.forEach((slider: HTMLElement) => {
              const sliderMenu: SliderInterface = {
                selector: `#${slider.id}`,
                options,
              };
              const sliderSwipper = new Slider(sliderMenu);
              sliderSwipper.create();
            });
          });
        },
        { once: true, passive: true }
      );
    }
  }
}
